import MyMap from './MyMap.vue'
export default MyMap
